'use strict';

import axios from '../lib/axios/axios';
// import qs from '../../p/qs/qs';
import { ajax as ajax_params } from './params';

// var instance = axios.create({
//     responseType: ajax_params.DATA_TYPE,
//     timeout: ajax_params.TIMEOUT
// });

function getAjax(data, options){
    if (ajax_params.SESSION_ID) {
        data['SESS_ID'] = ajax_params.SESSION_ID;
    }
    var url = ajax_params.URI;
    var method = ajax_params.METHOD;

    // var timeout = proj.AJAX_TIMEOUT;
    // var dataType = proj.AJAX_DATA_TYPE;

    if (options) {
        if (options.url) {
            url = options.url;
            delete options['url'];
        }
        if (options.method) {
            method = options.method;
            delete options['method'];
        }
    }
    if (data._do) {
        url = url + data._do + '/';
        delete data._do;
    } else {
        if ((options) && (options._do)) {
            url = url + options._do + '/';
            delete options['_do'];
        }
    }

    if(method === 'post'){
        return axios.post(url, JSONToURLEncoded(data), options);
    }

    return axios.get(url, { params: data }, options);
}

function JSONToURLEncoded(json) {
    var params = new URLSearchParams();
    if(json.constructor === Array){
        for (var idx in json) {
            params.append(json[idx]['name'], json[idx]['value']);
        }
    } else {
        for (var key in json) {
            params.append(key, json[key]);
        }
    }

    return params;
}

export { getAjax };
